package com.starparty.app.astro0.celestialobjects

import com.starparty.app.astro0.SP_Colour
import com.starparty.app.astro0.SP_Time
import com.starparty.app.vector_maths.Matrix4d

class Orrery(t: SP_Time) {
    protected var SUN = 0
    protected var MOON = 1
    protected var MERCURY = 2
    protected var VENUS = 3
    protected var MARS = 4
    protected var JUPITER = 5
    protected var SATURN = 6
    protected var URANUS = 7
    protected var NEPTUNE = 8
    protected var PLUTO = 9

    val distanceOrder = intArrayOf(NEPTUNE,URANUS,SATURN,JUPITER,MARS,SUN,MERCURY,VENUS,MOON)

    var isShowingObjects = true

    var bodies: Array<OrbitalBody>
        protected set

    /** Sets the locations of all the bodies  */
    fun project(transform: Matrix4d) {
        for (b in bodies.indices) {
            val body = bodies[b]
            body.setSkyLocation(transform)
        }
    }


    fun setTime(t:SP_Time) {
        recalculateCoordinates(t)
    }


    fun recalculateCoordinates(t: SP_Time) {
        for (b in bodies.indices) {
            bodies[b].recalculateOrbitalElements(t)
        }
        for (b in bodies.indices) {
            bodies[b].recalculateCartesianCoordinates(t)
        }
    }

    init {
        val bodiesTemp: MutableList<OrbitalBody> = mutableListOf()
        bodiesTemp.add(Sun(t))
        bodiesTemp.add(Moon(bodiesTemp[SUN] as Sun))
        bodiesTemp.add(Planet(bodiesTemp[SUN] as Sun)) // Mercury
        bodiesTemp.add(Planet(bodiesTemp[SUN] as Sun)) // Venus
        bodiesTemp.add(Planet(bodiesTemp[SUN] as Sun)) // Mars
        bodiesTemp.add(Jupiter(bodiesTemp[SUN] as Sun))
        bodiesTemp.add(Saturn(bodiesTemp[SUN] as Sun))
        bodiesTemp.add(Uranus(bodiesTemp[SUN] as Sun))
        bodiesTemp.add(Planet(bodiesTemp[SUN] as Sun)) // Neptune
      //  bodiesTemp.add(Pluto(bodiesTemp[SUN] as Sun))

        bodies = bodiesTemp.toTypedArray()

        (bodies[JUPITER] as Jupiter).setSaturn(bodies[SATURN] as Saturn)
        (bodies[SATURN] as Saturn).setJupiter(bodies[JUPITER] as Jupiter)
        (bodies[URANUS] as Uranus).setJupiter(bodies[JUPITER] as Jupiter)
        (bodies[URANUS] as Uranus).setSaturn(bodies[SATURN] as Saturn)
        bodies[MERCURY].name = "Mercury"
        bodies[MERCURY].abbrevName = "\u263F"
        bodies[MERCURY].setOrbitalElementsData(Planet.OE_MERCURY)
        bodies[VENUS].name = "Venus"
        bodies[VENUS].abbrevName = "\u2640"
        bodies[VENUS].rgbColour = SP_Colour(220, 255, 100,255)
        bodies[VENUS].setOrbitalElementsData(Planet.OE_VENUS)
        bodies[VENUS].hasPhases = true
        bodies[MARS].name = "Mars"
        bodies[MARS].abbrevName = "\u2642"
        bodies[MARS].rgbColour = SP_Colour(255, 124, 5, 255)
        bodies[MARS].setOrbitalElementsData(Planet.OE_MARS)
        bodies[NEPTUNE].name = "Neptune"
        bodies[NEPTUNE].abbrevName = "\u2646"
        bodies[NEPTUNE].rgbColour = SP_Colour(50, 100, 255,255)
        bodies[NEPTUNE].setOrbitalElementsData(Planet.OE_NEPTUNE)

        recalculateCoordinates(t)
    }
}